import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { subscribeToNewsletterApi } from '../api/newsletter';

export const Footer = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'danger'

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;

        setLoading(true);
        setMessage('');
        try {
            const response = await subscribeToNewsletterApi({ email });
            setMessage(response.message || 'Successfully subscribed!');
            setMessageType('success');
            setEmail('');
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Failed to subscribe. Please try again.';
            setMessage(errorMsg);
            setMessageType('danger');
        } finally {
            setLoading(false);
            // Hide message after 5 seconds
            setTimeout(() => {
                setMessage('');
            }, 5000);
        }
    };

    return (
        <footer className="footer-wrapper text-sm bg-theme2 text-theme4">
            <div className="container-xl py-5">
                <Row className="gx-3 gy-4">
                    <Col md={12} lg={4}>
                        <div className="wrapper text-center text-md-start mx-auto mx-md-0" style={{ maxWidth: '380px' }}>
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Let's Work Together</div>
                            <div className="description text-sm mb-3">
                                Let’s collaborate to empower learners through meaningful Language learning.
                                Yoospeak combines smart technology with expert teaching for real progress.
                                Our vision is to build a global community of confident communicators.
                            </div>
                            <div className="social-sec d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-2">
                                <Link to={"https://www.facebook.com/@kridemy?lang=en"} target='_blank'><img src={require('../assets/images/facebook.png')} className="img-fluid" alt="Facebook" /></Link>
                                <Link to={"https://www.instagram.com/"} target='_blank'><img src={require('../assets/images/instagram.png')} className="img-fluid" alt="Instagram" /></Link>
                                <Link to={"https://www.linkedin.com/company/"} target='_blank'><img src={require('../assets/images/linkedin.png')} className="img-fluid" alt="Linkedin" /></Link>
                                <Link to={"https://www.reddit.com/"} target='_blank'><img src={require('../assets/images/reddit.png')} className="img-fluid" alt="Reddit" /></Link>
                            </div>
                        </div>
                    </Col>
                    <Col md={3} lg={2}>
                        <div className="wrapper text-center text-md-start">
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Quick Links</div>
                            <ul className="nav flex-column gap-2">
                                <li className="nav-item"><Link to={'/'} className="nav-link">Home</Link></li>
                                <li className="nav-item"><Link to={'/about'} className="nav-link">About Us</Link></li>
                                <li className="nav-item"><Link to={'/contact'} className="nav-link">Contact Us</Link></li>
                                <li className="nav-item"><Link to={'/terms-of-service'} className="nav-link">Terms of Service</Link></li>
                                <li className="nav-item"><Link to={'/privacy-policy'} className="nav-link">Privacy Policy</Link></li>
                                <li className="nav-item"><Link to={'/refund-policy'} className="nav-link">Refund Policy</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={3} lg={2}>
                        <div className="wrapper text-center text-md-start">
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Explore</div>
                            <ul className="nav flex-column gap-2">
                                <li className="nav-item"><Link to={'/courses'} className="nav-link">Courses</Link></li>
                                <li className="nav-item"><Link to={'/classes'} className="nav-link">Classes</Link></li>
                                <li className="nav-item"><Link to={'/communities'} className="nav-link">Communities</Link></li>
                                <li className="nav-item"><Link to={'/marketplace'} className="nav-link">Teachers</Link></li>
                                <li className="nav-item"><Link to={'/features'} className="nav-link">Features</Link></li>
                                <li className="nav-item"><Link to={'/marketplace'} className="nav-link">Marketplace</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={6} lg={4}>
                        <div className="wrapper text-center text-md-start mx-auto mx-md-0" style={{ maxWidth: '450px' }}>
                            <div className="menu-header fs-5 fw-semibold text-primary mb-3">Our Newsletter</div>
                            <Form className="mb-4" onSubmit={handleSubscribe}>
                                <Form.Group>
                                    <InputGroup>
                                        <Form.Control 
                                            type="email" 
                                            className="shadow-none" 
                                            placeholder="Write your email here.." 
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required 
                                            disabled={loading}
                                        />
                                        <Button variant="primary" type="submit" size='lg' disabled={loading}>
                                            {loading ? 'Subscribing...' : 'Subscribe'}
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                                {message && (
                                    <div className={`mt-2 text-${messageType === 'success' ? 'success' : 'danger'} fw-semibold`}>
                                        {message}
                                    </div>
                                )}
                            </Form>
                            <div className="contact-number mb-2">
                                <Link to={'tel:+1 3174576046'} className="d-inline-flex align-items-center gap-2 text-theme4 text-decoration-none">
                                    <i className="bi bi-telephone-fill text-base text-primary lh-1"></i> +1 3174576046
                                </Link>
                            </div>
                            <div className="contact-email mb-2">
                                <Link to={'mailto:yousseljesus@gmail.com'} className="d-inline-flex align-items-center gap-2 text-theme4 text-decoration-none">
                                    <i className="bi bi-envelope-fill text-base text-primary lh-1"></i> yousseljesus@gmail.com
                                </Link>
                            </div>
                            <div className="contact-address d-inline-flex align-items-center gap-2">
                                <i className="bi bi-geo-alt-fill text-base text-primary lh-1"></i> 801 Broken bow Trail, Indianapolis, Indiana 46214
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="copyright-sec bg-theme1 py-3">
                <div className="container">
                    <div className="copyright-wrapper text-sm fw-medium text-center text-light">
                        <div className="copyright-text">© Yoospeak 2025. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

